module.exports = __webpack_public_path__ + "img/PS.f8857041.png";